import { defineMessages } from 'react-intl';

const messages = defineMessages({
  verifyEmail: {
    description: 'verify email title',
    defaultMessage: 'Verify Email',
    id: 'Xv9ec4',
  },
  resendEmail: {
    description: 'verify email resend email text',
    defaultMessage: 'Resend Email',
    id: '3CmkuX',
  },
  oneMoment: {
    description: 'verify email one moment text',
    defaultMessage: 'One moment please',
    id: 'cqMwOp',
  },
  verifyErrorMessage: {
    description: 'verify email error message',
    defaultMessage: 'There was an error while verifying your email.',
    id: 'FQ6ydV',
  },
});

export default messages;
